/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ArticleOut,
  ArticleUpsert,
  ClientCreate,
  ClientDetail,
  ClientOut,
  ClientUpdate,
  ClientsListClientsParams,
  DeliveryPointAliasOut,
  DeliveryPointCreate,
  DeliveryPointOut,
  DeliveryPointUpdate,
  PageClientOut,
  PointAliasCreate,
  ProblemDetail
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Список клиентов (поиск по названию, сети, началу ИНН)
 */
export const clientsListClients = (
    params?: ClientsListClientsParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<PageClientOut>(
      {url: `/api/v1/clients`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getClientsListClientsQueryKey = (params?: ClientsListClientsParams,) => {
    return [
    `/api/v1/clients`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getClientsListClientsQueryOptions = <TData = Awaited<ReturnType<typeof clientsListClients>>, TError = ErrorType<ProblemDetail>>(params?: ClientsListClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListClients>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientsListClientsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientsListClients>>> = ({ signal }) => clientsListClients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientsListClients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientsListClientsQueryResult = NonNullable<Awaited<ReturnType<typeof clientsListClients>>>
export type ClientsListClientsQueryError = ErrorType<ProblemDetail>


export function useClientsListClients<TData = Awaited<ReturnType<typeof clientsListClients>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  ClientsListClientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListClients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientsListClients>>,
          TError,
          Awaited<ReturnType<typeof clientsListClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientsListClients<TData = Awaited<ReturnType<typeof clientsListClients>>, TError = ErrorType<ProblemDetail>>(
 params?: ClientsListClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListClients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientsListClients>>,
          TError,
          Awaited<ReturnType<typeof clientsListClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientsListClients<TData = Awaited<ReturnType<typeof clientsListClients>>, TError = ErrorType<ProblemDetail>>(
 params?: ClientsListClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListClients>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Список клиентов (поиск по названию, сети, началу ИНН)
 */

export function useClientsListClients<TData = Awaited<ReturnType<typeof clientsListClients>>, TError = ErrorType<ProblemDetail>>(
 params?: ClientsListClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListClients>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientsListClientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create Client
 */
export const clientsCreateClient = (
    clientCreate: BodyType<ClientCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ClientOut>(
      {url: `/api/v1/clients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clientCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getClientsCreateClientMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsCreateClient>>, TError,{data: BodyType<ClientCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof clientsCreateClient>>, TError,{data: BodyType<ClientCreate>}, TContext> => {

const mutationKey = ['clientsCreateClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientsCreateClient>>, {data: BodyType<ClientCreate>}> = (props) => {
          const {data} = props ?? {};

          return  clientsCreateClient(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClientsCreateClientMutationResult = NonNullable<Awaited<ReturnType<typeof clientsCreateClient>>>
    export type ClientsCreateClientMutationBody = BodyType<ClientCreate>
    export type ClientsCreateClientMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Create Client
 */
export const useClientsCreateClient = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsCreateClient>>, TError,{data: BodyType<ClientCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clientsCreateClient>>,
        TError,
        {data: BodyType<ClientCreate>},
        TContext
      > => {

      const mutationOptions = getClientsCreateClientMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Клиент с точками доставки и их алиасами
 */
export const clientsGetClient = (
    clientId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ClientDetail>(
      {url: `/api/v1/clients/${clientId}`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getClientsGetClientQueryKey = (clientId?: number,) => {
    return [
    `/api/v1/clients/${clientId}`
    ] as const;
    }

    
export const getClientsGetClientQueryOptions = <TData = Awaited<ReturnType<typeof clientsGetClient>>, TError = ErrorType<ProblemDetail>>(clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsGetClient>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientsGetClientQueryKey(clientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientsGetClient>>> = ({ signal }) => clientsGetClient(clientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientsGetClient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientsGetClientQueryResult = NonNullable<Awaited<ReturnType<typeof clientsGetClient>>>
export type ClientsGetClientQueryError = ErrorType<ProblemDetail>


export function useClientsGetClient<TData = Awaited<ReturnType<typeof clientsGetClient>>, TError = ErrorType<ProblemDetail>>(
 clientId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsGetClient>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientsGetClient>>,
          TError,
          Awaited<ReturnType<typeof clientsGetClient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientsGetClient<TData = Awaited<ReturnType<typeof clientsGetClient>>, TError = ErrorType<ProblemDetail>>(
 clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsGetClient>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientsGetClient>>,
          TError,
          Awaited<ReturnType<typeof clientsGetClient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientsGetClient<TData = Awaited<ReturnType<typeof clientsGetClient>>, TError = ErrorType<ProblemDetail>>(
 clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsGetClient>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Клиент с точками доставки и их алиасами
 */

export function useClientsGetClient<TData = Awaited<ReturnType<typeof clientsGetClient>>, TError = ErrorType<ProblemDetail>>(
 clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsGetClient>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientsGetClientQueryOptions(clientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update Client
 */
export const clientsUpdateClient = (
    clientId: number,
    clientUpdate: BodyType<ClientUpdate>,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<ClientOut>(
      {url: `/api/v1/clients/${clientId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: clientUpdate
    },
      options);
    }
  


export const getClientsUpdateClientMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsUpdateClient>>, TError,{clientId: number;data: BodyType<ClientUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof clientsUpdateClient>>, TError,{clientId: number;data: BodyType<ClientUpdate>}, TContext> => {

const mutationKey = ['clientsUpdateClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientsUpdateClient>>, {clientId: number;data: BodyType<ClientUpdate>}> = (props) => {
          const {clientId,data} = props ?? {};

          return  clientsUpdateClient(clientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClientsUpdateClientMutationResult = NonNullable<Awaited<ReturnType<typeof clientsUpdateClient>>>
    export type ClientsUpdateClientMutationBody = BodyType<ClientUpdate>
    export type ClientsUpdateClientMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Update Client
 */
export const useClientsUpdateClient = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsUpdateClient>>, TError,{clientId: number;data: BodyType<ClientUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clientsUpdateClient>>,
        TError,
        {clientId: number;data: BodyType<ClientUpdate>},
        TContext
      > => {

      const mutationOptions = getClientsUpdateClientMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Артикулы покупателя → товары
 */
export const clientsListArticles = (
    clientId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ArticleOut[]>(
      {url: `/api/v1/clients/${clientId}/articles`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getClientsListArticlesQueryKey = (clientId?: number,) => {
    return [
    `/api/v1/clients/${clientId}/articles`
    ] as const;
    }

    
export const getClientsListArticlesQueryOptions = <TData = Awaited<ReturnType<typeof clientsListArticles>>, TError = ErrorType<ProblemDetail>>(clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListArticles>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientsListArticlesQueryKey(clientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientsListArticles>>> = ({ signal }) => clientsListArticles(clientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientsListArticles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientsListArticlesQueryResult = NonNullable<Awaited<ReturnType<typeof clientsListArticles>>>
export type ClientsListArticlesQueryError = ErrorType<ProblemDetail>


export function useClientsListArticles<TData = Awaited<ReturnType<typeof clientsListArticles>>, TError = ErrorType<ProblemDetail>>(
 clientId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListArticles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientsListArticles>>,
          TError,
          Awaited<ReturnType<typeof clientsListArticles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientsListArticles<TData = Awaited<ReturnType<typeof clientsListArticles>>, TError = ErrorType<ProblemDetail>>(
 clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListArticles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientsListArticles>>,
          TError,
          Awaited<ReturnType<typeof clientsListArticles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientsListArticles<TData = Awaited<ReturnType<typeof clientsListArticles>>, TError = ErrorType<ProblemDetail>>(
 clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListArticles>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Артикулы покупателя → товары
 */

export function useClientsListArticles<TData = Awaited<ReturnType<typeof clientsListArticles>>, TError = ErrorType<ProblemDetail>>(
 clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientsListArticles>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientsListArticlesQueryOptions(clientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete Article
 */
export const clientsDeleteArticle = (
    clientId: number,
    article: string,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<void>(
      {url: `/api/v1/clients/${clientId}/articles/${article}`, method: 'DELETE'
    },
      options);
    }
  


export const getClientsDeleteArticleMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsDeleteArticle>>, TError,{clientId: number;article: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof clientsDeleteArticle>>, TError,{clientId: number;article: string}, TContext> => {

const mutationKey = ['clientsDeleteArticle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientsDeleteArticle>>, {clientId: number;article: string}> = (props) => {
          const {clientId,article} = props ?? {};

          return  clientsDeleteArticle(clientId,article,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClientsDeleteArticleMutationResult = NonNullable<Awaited<ReturnType<typeof clientsDeleteArticle>>>
    
    export type ClientsDeleteArticleMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Delete Article
 */
export const useClientsDeleteArticle = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsDeleteArticle>>, TError,{clientId: number;article: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clientsDeleteArticle>>,
        TError,
        {clientId: number;article: string},
        TContext
      > => {

      const mutationOptions = getClientsDeleteArticleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Привязать артикул к товару (с квантом для фасовки)
 */
export const clientsUpsertArticle = (
    clientId: number,
    article: string,
    articleUpsert: BodyType<ArticleUpsert>,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<ArticleOut>(
      {url: `/api/v1/clients/${clientId}/articles/${article}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: articleUpsert
    },
      options);
    }
  


export const getClientsUpsertArticleMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsUpsertArticle>>, TError,{clientId: number;article: string;data: BodyType<ArticleUpsert>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof clientsUpsertArticle>>, TError,{clientId: number;article: string;data: BodyType<ArticleUpsert>}, TContext> => {

const mutationKey = ['clientsUpsertArticle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientsUpsertArticle>>, {clientId: number;article: string;data: BodyType<ArticleUpsert>}> = (props) => {
          const {clientId,article,data} = props ?? {};

          return  clientsUpsertArticle(clientId,article,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClientsUpsertArticleMutationResult = NonNullable<Awaited<ReturnType<typeof clientsUpsertArticle>>>
    export type ClientsUpsertArticleMutationBody = BodyType<ArticleUpsert>
    export type ClientsUpsertArticleMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Привязать артикул к товару (с квантом для фасовки)
 */
export const useClientsUpsertArticle = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsUpsertArticle>>, TError,{clientId: number;article: string;data: BodyType<ArticleUpsert>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clientsUpsertArticle>>,
        TError,
        {clientId: number;article: string;data: BodyType<ArticleUpsert>},
        TContext
      > => {

      const mutationOptions = getClientsUpsertArticleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Create Delivery Point
 */
export const clientsCreateDeliveryPoint = (
    clientId: number,
    deliveryPointCreate: BodyType<DeliveryPointCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<DeliveryPointOut>(
      {url: `/api/v1/clients/${clientId}/delivery-points`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deliveryPointCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getClientsCreateDeliveryPointMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsCreateDeliveryPoint>>, TError,{clientId: number;data: BodyType<DeliveryPointCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof clientsCreateDeliveryPoint>>, TError,{clientId: number;data: BodyType<DeliveryPointCreate>}, TContext> => {

const mutationKey = ['clientsCreateDeliveryPoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientsCreateDeliveryPoint>>, {clientId: number;data: BodyType<DeliveryPointCreate>}> = (props) => {
          const {clientId,data} = props ?? {};

          return  clientsCreateDeliveryPoint(clientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClientsCreateDeliveryPointMutationResult = NonNullable<Awaited<ReturnType<typeof clientsCreateDeliveryPoint>>>
    export type ClientsCreateDeliveryPointMutationBody = BodyType<DeliveryPointCreate>
    export type ClientsCreateDeliveryPointMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Create Delivery Point
 */
export const useClientsCreateDeliveryPoint = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsCreateDeliveryPoint>>, TError,{clientId: number;data: BodyType<DeliveryPointCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clientsCreateDeliveryPoint>>,
        TError,
        {clientId: number;data: BodyType<DeliveryPointCreate>},
        TContext
      > => {

      const mutationOptions = getClientsCreateDeliveryPointMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update Delivery Point
 */
export const clientsUpdateDeliveryPoint = (
    clientId: number,
    dpId: number,
    deliveryPointUpdate: BodyType<DeliveryPointUpdate>,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<DeliveryPointOut>(
      {url: `/api/v1/clients/${clientId}/delivery-points/${dpId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: deliveryPointUpdate
    },
      options);
    }
  


export const getClientsUpdateDeliveryPointMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsUpdateDeliveryPoint>>, TError,{clientId: number;dpId: number;data: BodyType<DeliveryPointUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof clientsUpdateDeliveryPoint>>, TError,{clientId: number;dpId: number;data: BodyType<DeliveryPointUpdate>}, TContext> => {

const mutationKey = ['clientsUpdateDeliveryPoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientsUpdateDeliveryPoint>>, {clientId: number;dpId: number;data: BodyType<DeliveryPointUpdate>}> = (props) => {
          const {clientId,dpId,data} = props ?? {};

          return  clientsUpdateDeliveryPoint(clientId,dpId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClientsUpdateDeliveryPointMutationResult = NonNullable<Awaited<ReturnType<typeof clientsUpdateDeliveryPoint>>>
    export type ClientsUpdateDeliveryPointMutationBody = BodyType<DeliveryPointUpdate>
    export type ClientsUpdateDeliveryPointMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Update Delivery Point
 */
export const useClientsUpdateDeliveryPoint = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsUpdateDeliveryPoint>>, TError,{clientId: number;dpId: number;data: BodyType<DeliveryPointUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clientsUpdateDeliveryPoint>>,
        TError,
        {clientId: number;dpId: number;data: BodyType<DeliveryPointUpdate>},
        TContext
      > => {

      const mutationOptions = getClientsUpdateDeliveryPointMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Привязать текст графы «Грузополучатель» к точке
 */
export const clientsAddPointAlias = (
    clientId: number,
    dpId: number,
    pointAliasCreate: BodyType<PointAliasCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<DeliveryPointAliasOut>(
      {url: `/api/v1/clients/${clientId}/delivery-points/${dpId}/aliases`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pointAliasCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getClientsAddPointAliasMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsAddPointAlias>>, TError,{clientId: number;dpId: number;data: BodyType<PointAliasCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof clientsAddPointAlias>>, TError,{clientId: number;dpId: number;data: BodyType<PointAliasCreate>}, TContext> => {

const mutationKey = ['clientsAddPointAlias'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientsAddPointAlias>>, {clientId: number;dpId: number;data: BodyType<PointAliasCreate>}> = (props) => {
          const {clientId,dpId,data} = props ?? {};

          return  clientsAddPointAlias(clientId,dpId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClientsAddPointAliasMutationResult = NonNullable<Awaited<ReturnType<typeof clientsAddPointAlias>>>
    export type ClientsAddPointAliasMutationBody = BodyType<PointAliasCreate>
    export type ClientsAddPointAliasMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Привязать текст графы «Грузополучатель» к точке
 */
export const useClientsAddPointAlias = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsAddPointAlias>>, TError,{clientId: number;dpId: number;data: BodyType<PointAliasCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clientsAddPointAlias>>,
        TError,
        {clientId: number;dpId: number;data: BodyType<PointAliasCreate>},
        TContext
      > => {

      const mutationOptions = getClientsAddPointAliasMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete Point Alias
 */
export const clientsDeletePointAlias = (
    clientId: number,
    dpId: number,
    aliasId: number,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<void>(
      {url: `/api/v1/clients/${clientId}/delivery-points/${dpId}/aliases/${aliasId}`, method: 'DELETE'
    },
      options);
    }
  


export const getClientsDeletePointAliasMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsDeletePointAlias>>, TError,{clientId: number;dpId: number;aliasId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof clientsDeletePointAlias>>, TError,{clientId: number;dpId: number;aliasId: number}, TContext> => {

const mutationKey = ['clientsDeletePointAlias'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientsDeletePointAlias>>, {clientId: number;dpId: number;aliasId: number}> = (props) => {
          const {clientId,dpId,aliasId} = props ?? {};

          return  clientsDeletePointAlias(clientId,dpId,aliasId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClientsDeletePointAliasMutationResult = NonNullable<Awaited<ReturnType<typeof clientsDeletePointAlias>>>
    
    export type ClientsDeletePointAliasMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Delete Point Alias
 */
export const useClientsDeletePointAlias = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientsDeletePointAlias>>, TError,{clientId: number;dpId: number;aliasId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clientsDeletePointAlias>>,
        TError,
        {clientId: number;dpId: number;aliasId: number},
        TContext
      > => {

      const mutationOptions = getClientsDeletePointAliasMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    